import { z } from 'zod';
import { msObject } from '../../../resource-base/msObject';

export const UserEffectiveRightsResourceSchema = msObject({
    isReader: z.boolean(),
    isManager: z.boolean(),
    isProcessAdmin: z.boolean(),
    isAdmin: z.boolean(),
    isServerAdmin: z.boolean(),
});

export type UserEffectiveRightsResource = z.infer<typeof UserEffectiveRightsResourceSchema>;
